/**
 * Dashboard Page
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logger, LogCategory } from '@/utils/logger';
import { AppLayout, PageHeader } from '@/components/layout';
import { Button } from '@/components/ui/Button';
import {
  StatsGrid,
  FlagsTrendChart,
  FlagsBySourceChart,
  RecentFlaggedList,
} from '@/components/dashboard';
import { ROUTES } from '@/constants';
import { Plus, Upload, CreditCard } from 'lucide-react';

export function DashboardPage() {
  const navigate = useNavigate();

  useEffect(() => {
    Logger.info(LogCategory.UI, 'DashboardPage mounted', 'DashboardPage');
    Logger.startTimer('dashboardPageLoad');

    return () => {
      Logger.endTimer('dashboardPageLoad');
    };
  }, []);

  const handleAddNumbers = () => {
    Logger.info(LogCategory.NAVIGATION, 'Navigate to add phone numbers', 'DashboardPage');
    navigate(ROUTES.PHONE_NUMBERS);
  };

  const handleBuyCredits = () => {
    Logger.info(LogCategory.NAVIGATION, 'Navigate to billing', 'DashboardPage');
    navigate(ROUTES.SETTINGS_BILLING);
  };

  return (
    <AppLayout>
      <PageHeader
        title="Dashboard"
        description="Monitor your phone number reputation at a glance"
        actions={
          <>
            <Button
              variant="outline"
              leftIcon={<CreditCard className="h-4 w-4" />}
              onClick={handleBuyCredits}
            >
              Buy Credits
            </Button>
            <Button
              leftIcon={<Plus className="h-4 w-4" />}
              onClick={handleAddNumbers}
            >
              Add Numbers
            </Button>
          </>
        }
      />

      {/* Stats Grid */}
      <StatsGrid />

      {/* Charts Row */}
      <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <FlagsTrendChart />
        <FlagsBySourceChart />
      </div>

      {/* Recent Flagged */}
      <div className="mt-6">
        <RecentFlaggedList />
      </div>
    </AppLayout>
  );
}
